import { namespacedConsts } from '../../utils/object'
import { appDispatcher } from '../../application/AppDispatcher'

const CLASS_CONSTATNTS = namespacedConsts({
  SOCIAL_BUTTONS: {
    ACTIONS: {
      EMBED_OPEN: true,
      EMBED_CLOSE: true,
    },
  },
})

export const TYPES = CLASS_CONSTATNTS.SOCIAL_BUTTONS.ACTIONS

export function openEmbed(caller, position, title, e) {
  appDispatcher.dispatchAction.view({
    type: TYPES.EMBED_OPEN,
    dispatchToRedux: true,
  })
}

export function closeEmbed(caller, e) {
  appDispatcher.dispatchAction.view({
    type: TYPES.EMBED_CLOSE,
  })
}

export const socialButtonsAction = { openEmbed, closeEmbed }



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/actions/socialButtonsActions.js